import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, tap, throwError } from "rxjs";
import { Injectable, Injector } from "@angular/core";
import { AuthenticationSecretsService } from "../authentications-secrets.service";
import { AuthenticationService } from "../authentication.service";

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  // We must work with the injector here to break cyclic dependencies during injection
  constructor(private readonly injector: Injector) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: (err) => {
          if (err instanceof HttpErrorResponse) {
            // We detect a invalid token either by a 401 response or a 404 response
            // and a expired Lifetime of the current saved token
            if (
              (err.status === 401 &&
                this.injector.get(AuthenticationSecretsService).accessToken &&
                this.injector.get(AuthenticationSecretsService)
                  .lifeTimeExpired) ||
              ((err.status === 404 || err.status === 405) &&
                this.injector.get(AuthenticationSecretsService).accessToken &&
                this.injector.get(AuthenticationSecretsService).lifeTimeExpired)
            ) {
              this.injector
                .get(AuthenticationService)
                .refreshWithRefreshToken();
              console.debug("Refreshed access token with refresh token");
              return;
            } else {
              return throwError(() => err);
            }
          } else {
            return throwError(() => err);
          }
        },
      })
    );
  }
}
